import script from "./ImagesTrail.vue?vue&type=script&setup=true&lang=js"
export * from "./ImagesTrail.vue?vue&type=script&setup=true&lang=js"

import "./ImagesTrail.vue?vue&type=style&index=0&id=64c00d30&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64c00d30"]])

export default __exports__